import { Component, Input, inject } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'app-modal-confirm-user-status',
  templateUrl: './modal-confirm-user-status.component.html',
  styleUrl: './modal-confirm-user-status.component.scss'
})
export class ModalConfirmUserStatusComponent {
  private _modalservice = inject(ModalService);
  isLoading = false;

  @Input() showBtns = true;
  @Input() showClose = true;
  @Input() isActivation = false;

  onConfirm() {
    this.isLoading = true;
    setTimeout(() => {
      this._modalservice.close('confirm');
      this.isLoading = false;
    }, 300);
  }

  onCancel() {
    this._modalservice.close('cancel');
  }
}
